export default __webpack_public_path__ + "static/media/Spellguard Helm.00d9b2dd.jpg";